// extracted by mini-css-extract-plugin
module.exports = {"container":"blacklistSame_container__3UyOz"};